module.exports = __webpack_public_path__ + "static/media/cicek5.8274709c.jpg";